import './style.scss';
import psl_ui from '../../libs/psl_ui.js';
import psl_actions from '../../libs/psl_actions.js';
import template from './template.pst';
import template_card from './template_card.pst';
import state from "../../state.js";

import {wait} from '../../libs/psl_polyfills.js';

import CONFIG from '../../CONFIG.js';

import {rem_to_px} from '../../libs/helpers.js';

psl_ui.templates.add('small_cards',template);
psl_ui.templates.add('small_card',template_card);

const WIDTH=476;

const START_X=0;
const START_Y='100% + 2.4rem';
const STEP_X=`${WIDTH}px + 2.4rem`;
const STEP_ROW=`125px + 1.2rem`;

class SmallCards{
	constructor(section_data){
		const {el, rpoints} = psl_ui.templates.render('small_cards');

		this._rpoints=rpoints;
		this.view=el;
		this.view.controller=this;

		this.data=section_data;

		window.addEventListener('resize',()=>{
			this._render_positions();
		},{passive:true});

		this._rpoints.wrapper.addEventListener('pointerdown',(e)=>{
			if(!window.matchMedia('(min-width: 769px)').matches) return;
			// const target = e.target;
			// const interactive = target.closest('button, a, [data-action]');
			// if(interactive && interactive !== this._rpoints.wrapper){
			// 	return;
			// }
			this._pointer_start_x = e.clientX;
			this._scroll_start_x = this._rpoints.wrapper.scrollLeft;
			this._is_dragging = false;
			this._has_moved = false;
			this._pointer_id = e.pointerId;
			//this._rpoints.wrapper.setPointerCapture(e.pointerId);
		});

		this._rpoints.wrapper.addEventListener('pointermove',(e)=>{
			if(!window.matchMedia('(min-width: 769px)').matches || this._pointer_start_x === undefined || e.pointerId !== this._pointer_id) return;
			const delta_x = Math.abs(this._pointer_start_x - e.clientX);
			if(delta_x > 5){
				if(!this._is_dragging){
					psl_actions.break();
					this._is_dragging = true;
					this._has_moved = true;
					this._rpoints.wrapper.style.cursor = 'grabbing';
					this._rpoints.wrapper.style.userSelect = 'none';
				}
				this._rpoints.wrapper.scrollLeft = this._scroll_start_x + (this._pointer_start_x - e.clientX);
			}
		});

		this._rpoints.wrapper.addEventListener('pointerup',(e)=>{
			if(e.pointerId !== this._pointer_id) return;
			if(this._is_dragging){
				this._is_dragging = false;
				this._rpoints.wrapper.style.cursor = '';
				this._rpoints.wrapper.style.userSelect = '';
				e.preventDefault();
			}
			this._pointer_start_x = undefined;
			this._pointer_id = undefined;
			//this._rpoints.wrapper.releasePointerCapture(e.pointerId);
		});

		this._rpoints.wrapper.addEventListener('pointercancel',(e)=>{
			if(e.pointerId !== this._pointer_id) return;
			if(this._is_dragging){
				this._is_dragging = false;
				this._rpoints.wrapper.style.cursor = '';
				this._rpoints.wrapper.style.userSelect = '';
			}
			this._pointer_start_x = undefined;
			this._pointer_id = undefined;
			//this._rpoints.wrapper.releasePointerCapture(e.pointerId);
		});
	}

	async on_submenu(){
		await this._hide_cards();
		if(this._rpoints.list.childNodes.length===this._rpoints.list.querySelectorAll('.hidden').length){
			this._render_positions();
			await wait(50);
		} else {
			await this._render_positions();
		}
		await this._show_cards();
	}

	async show(){
		this._hide_cards();
		this._render_positions();
		this._show_cards();
		await wait(50);
		this.view.classList.remove('hidden');
		await wait(350);
	}

	async hide(){
		this.view.classList.add('hidden');
		await wait(350);
	}

	set data(_){
		this._data=_;
		this._render();
	}

	get data(){
		return this._data;
	}

	_render(){
		this._rpoints.header.innerHTML=this._data.name||"";
		//this._rpoints.subheader.innerHTML=this._data.name||"";
		this.view.style.backgroundImage=`url("${CONFIG.backend_base_url}files/${this._data.bkg}")`;

		this._rpoints.list.innerHTMl='';

		this._data.cards.forEach(card=>{
			const {el} = psl_ui.templates.render('small_card',card);
			el.card=card;
			this._rpoints.list.appendChild(el);
		});

		this._render_positions();
	}

	async _hide_cards(){
		const is_mobile=!window.matchMedia('(min-width: 769px)').matches;
		if(is_mobile){
			this._rpoints.list.childNodes.forEach(el=>{
				el.classList.add('hidden');
			});
			await wait(350);
			let cats=new Set(this._data.submenu[state.submenu].categories);
			this._rpoints.list.childNodes.forEach(el=>{
				if(!cats.has(el.card.category)) el.classList.add('mobile_hidden');
				else el.classList.remove('mobile_hidden');
			});
		}else{
			let cats=new Set(this._data.submenu[state.submenu].categories);
			this._rpoints.list.childNodes.forEach(el=>{
				if(!cats.has(el.card.category)) el.classList.add('hidden');
			});
			await wait(350);
		}
	}

	async _show_cards(){
		let cats=new Set(this._data.submenu[state.submenu].categories);
		this._rpoints.list.childNodes.forEach(el=>{
			if(cats.has(el.card.category)) el.classList.remove('hidden');
		});
		await wait(350);
	}

	async _render_positions(){
		let i=0;
		let width=0;
		let cats=new Set(this._data.submenu[state.submenu].categories);

		this._rpoints.list.childNodes.forEach(el=>{
			let row=i%2;
			let n=Math.floor(i/2);

			const x=`${n}*(${STEP_X}) + ${(row===1?`${STEP_ROW}`:'0px')}`;
			const y=row===0?`calc(${START_Y})`:'0px';

			el.style.transform=`translate3d(calc(${x}), ${y}, 0px)`;

			if(cats.has(el.card.category)) i++;

			width=Math.max(width,n*(WIDTH + rem_to_px(2.4)) +row * (125 + rem_to_px(1.2))+WIDTH);
		});

		const old_width=parseInt(this._rpoints.list.style.width);

		if(old_width>width) await wait(400);

		this._rpoints.list.style.width=`${width}px`;

		if(old_width<=width) await wait(400);
	}
}

export default SmallCards;
